import {
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR
  } from "../../Types/user/Types";
  
  const initialState = {
    error: "",
    supporting_documents_out_put_file_upload_data: "",
    loader: false,
  };
  const BuildQuickOutPutFileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS:
        return {
          ...initialState.supporting_documents_out_put_file_upload_data,
          error: "",
          supporting_documents_out_put_file_upload_data: action.payload,
          loader: false,
        };
      case SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR:
        return {
          ...initialState.supporting_documents_out_put_file_upload_data,
          error: action.error,
          supporting_documents_out_put_file_upload_data: "",
          loader: false,
        };
      case SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST:
        return {
          ...initialState.supporting_documents_out_put_file_upload_data,
          error: null,
          supporting_documents_out_put_file_upload_data: "",
          loader: true,
        };
        case SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR:
            return {
                ...initialState.supporting_documents_out_put_file_upload_data,
                error: null,
                supporting_documents_out_put_file_upload_data: '',
                loader: false,
            };
      default:
        return state;
    }
  };
  export default BuildQuickOutPutFileUploadReducer;
  